<template>
    <div>
    <v-card height="450px" class="box" >
        <v-navigation-drawer
                absolute
                permanent
                left

        >

            <v-list dense >
                <router-link  :to="'/profile/' + this.applicantEmail" class="d-flex">
                    <v-list-item class="mt-5 "  >
                        <v-list-item-icon>
                            <v-img v-if="this.$route.path==='/profile/'+applicantEmail" src="../../../../assets/svg/summary-icon.svg" ></v-img>
                            <v-img v-else src="../../../../assets/svg/sum.svg" ></v-img>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title class="menu-font" :style="[this.$route.path==='/profile/'+applicantEmail ?{color:'#431288',border:'red'}:{color: 'rgba(43, 28, 28, 0.5)'}]">Summary</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
<!--                    <v-img src="../../../../assets/svg/summary-icon.svg" class="sideImg" ></v-img><span>Summary</span>-->
                </router-link>
                <br/>
                <router-link  to="/full-info" exact tag="a" >
                    <v-list-item>
                        <v-list-item-icon>
                            <v-img v-if="this.$route.path==='/full-info'"  src="../../../../assets/svg/fullOutline.svg" class="comment-box"></v-img>
                            <v-img v-else src="../../../../assets/svg/fullinfo.svg" class="comment-box"></v-img>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title  class="menu-font" :style="[this.$route.path==='/full-info' ?{color:'#431288',border:'red'}:{color: 'rgba(43, 28, 28, 0.5)'}]">Full Info</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </router-link>
                <br/>
                <router-link to="/test-info" exact tag="a">
                    <v-list-item >
                        <v-list-item-icon>
                            <v-img  v-if="this.$route.path==='/test-info'" src="../../../../assets/svg/testOutline.svg" class="decision-box"></v-img>
                            <v-img v-else src="../../../../assets/svg/Aptitude-Test.svg" class="decision-box"></v-img>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title  class="menu-font" :style="[this.$route.path==='/test-info' ?{color:'#431288',border:'red'}:{color: 'rgba(43, 28, 28, 0.5)'}]">Aptitude Test</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </router-link>
                <br/>
                    <router-link to="/activity" exact tag="a">
                    <v-list-item>
                        <v-list-item-icon>
                            <v-img  v-if="this.$route.path==='/activity'" src="../../../../assets/svg/actOutline.svg" class="decision-box"></v-img>
                            <v-img v-else src="../../../../assets/svg/ActivityLog.svg" class="decision-box"></v-img>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title class="menu-font" :style="[this.$route.path==='/activity' ?{color:'#431288',border:'red'}:{color: 'rgba(43, 28, 28, 0.5)'}]">Activity Log </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </router-link>
                <br/>
              <router-link to="/actions" exact tag="a">
                <v-list-item >
                  <v-list-item-icon>
                    <v-img  v-if="this.$route.path==='/actions'" src="../../../../assets/svg/actionsfill.svg" class="decision-box"></v-img>
                    <v-img v-else src="../../../../assets/svg/actions.svg" class="decision-box"></v-img>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title  class="menu-font" :style="[this.$route.path==='/actions' ?{color:'#431288',border:'red'}:{color: 'rgba(43, 28, 28, 0.5)'}]">Actions</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </router-link>
              <br/>
                <router-link to="/dashboard">
                <v-list-item>
                    <v-list-item-icon>
                        <v-img src="../../../../assets/svg/BackLogo.svg" class="decision-box"></v-img>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title  class="menu-font">Back to Records </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                </router-link>
                <br/>
            </v-list>
        </v-navigation-drawer>
    </v-card>
    </div>
</template>

<script>
    // import ElderHeader from "./ElderHeader";
    // import ApplicantMenu from "./ApplicantMenu";
    import {mapGetters} from "vuex";

    export default {
         name: "ApplicantRecordMenu",
        data(){
             return{

             }
        },
        computed:mapGetters(['applicantEmail'])


        // components: {ApplicantMenu, ElderHeader}
    }
</script>

<style scoped>
    .menu-font{
        font-family: IBM Plex Sans;
        font-style: normal !important;
        font-weight: 500 !important;
        font-size: 16px !important;
        line-height: 21px !important;
        display: flex !important;
        align-items: center !important;
        letter-spacing: 0.02em !important;

        color: rgba(43, 28, 28, 0.5);
    }
    .box{
        box-shadow: none!important;
    }
    a{
        text-decoration: none;
        cursor: pointer;
    }
    a :hover{
        color: #431288;
        cursor: pointer;
    }
    .sideImg{
        width: 15px !important;
    }
    a :active{
        /*border-color: red !important;*/
        color: #431288 !important;
        text-decoration: #431288;
        cursor: pointer;
    }


    a.router-link-active {
        color: #f66 !important;
    }
    .router-link-active :active{
        color: red !important;
    }
    .active{
        color: red !important;
    }




</style>